import React from 'react';

import { StyledYatSprite, Wrapper } from './styles';

export const FantasyRank = () => {
    return (
        <Wrapper>
            <StyledYatSprite emojiID="🦄" />
            Rank
            <span>84</span>
            In Yat Fantasy
        </Wrapper>
    );
};
